import { render } from "./BaseCabinetView.vue?vue&type=template&id=f496d1a8&lang=pug"
import script from "./BaseCabinetView.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseCabinetView.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__